/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'controller-interface';

export const controllerInterfaceBreadcrumbTitle = `${prefix}.controllerInterfaceBreadcrumbTitle`;

export const ENGLISH = {
    [controllerInterfaceBreadcrumbTitle]: 'Controller Interface',
};
